exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".markdown-markdown-Ufcq4pOKmwr{line-height:normal;word-wrap:break-word}.markdown-markdown-Ufcq4pOKmwr .token.punctuation{color:var(--primary-text)}.markdown-markdown-Ufcq4pOKmwr .token.tag{color:#0000ff}.markdown-markdown-Ufcq4pOKmwr .token.tag .attr-name{color:var(--code-class-name)}.markdown-markdown-Ufcq4pOKmwr .token.tag .attr-value{color:var(--syntax-token4)}.markdown-markdown-Ufcq4pOKmwr .token.tag .attr-value .punctuation:first-child{color:#F56D4F}.markdown-markdown-Ufcq4pOKmwr a,.markdown-markdown-Ufcq4pOKmwr :visited{color:var(--link-text)}.markdown-markdown-Ufcq4pOKmwr a:hover,.markdown-markdown-Ufcq4pOKmwr :visited:hover{color:var(--link-text-hover)}.markdown-padded-28esLFXVmwr{margin:1em 0}.markdown-code-block-3FSc63u8mwr{overflow:auto}.markdown-code-block-3FSc63u8mwr pre{margin:0;display:inline-block}.markdown-heading-hoSJpVJwmwr{display:flex;align-items:center;margin-left:-24px}.markdown-heading-hoSJpVJwmwr:hover .markdown-link-icon-aU1kXq93mwr{visibility:visible}.markdown-heading-hoSJpVJwmwr .markdown-link-icon-aU1kXq93mwr{opacity:0.5;display:flex;align-items:center;margin-right:8px;visibility:hidden}.markdown-heading-hoSJpVJwmwr .markdown-link-icon-aU1kXq93mwr img{width:20px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"markdown": "markdown-markdown-Ufcq4pOKmwr",
	"padded": "markdown-padded-28esLFXVmwr",
	"code-block": "markdown-code-block-3FSc63u8mwr",
	"codeBlock": "markdown-code-block-3FSc63u8mwr",
	"heading": "markdown-heading-hoSJpVJwmwr",
	"link-icon": "markdown-link-icon-aU1kXq93mwr",
	"linkIcon": "markdown-link-icon-aU1kXq93mwr"
};